import { CrisisAlert, SavingsOutlined, Today } from '@mui/icons-material';
import { Card } from '../Card';
import { ContentContainer } from '../containers';
import styled from 'styled-components';
import COLORS from '../../colors';
import { DEFINE_OPTION } from '../../constants';
import { Zeros } from '../Icons';
import { useState } from 'react';

interface CampaignSelectorProps {
  onChange: (selected: DEFINE_OPTION) => void;
}

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 0%;
  font-size: 16px;
`;

const DefineSelector = ({ onChange }: CampaignSelectorProps) => {
  const [selected, setSelected] = useState<DEFINE_OPTION | undefined>(
    undefined
  );

  const Cards = {
    0: {
      title: 'Define by Budget',
      supportingText: '',
      icon: <SavingsOutlined />,
      value: DEFINE_OPTION.BUDGET
    },
    1: {
      title: 'Define by 000s',
      supportingText: '',
      icon: <Zeros />,
      value: DEFINE_OPTION.ZEROS
    },
    2: {
      title: 'Define by TARPs',
      supportingText: '',
      icon: <CrisisAlert />,
      value: DEFINE_OPTION.TARPS
    }
  };

  const handleOnChange = (selected: DEFINE_OPTION) => {
    onChange(selected);
    setSelected(selected);
  };

  return (
    <ContentContainer>
      <h2>Define Target by</h2>
      <StyledContainer>
        {Object.values(Cards).map((card) => (
          <Card
            title={card.title}
            supportingText={card.supportingText}
            icon={card.icon}
            checked={selected === card.value}
            onChange={() => handleOnChange(card.value)}
            value={card.value}
            key={card.value}
            backgroundColor={COLORS.NEUTRAL_900}
          />
        ))}
      </StyledContainer>
    </ContentContainer>
  );
};

export default DefineSelector;
